import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import { Loader2, Mail, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterSubscribeForm = ({ variant = 'default' }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/newsletter/subscribe`, {
        email,
        name: name || undefined
      });
      setSubscribed(true);
      toast.success('Successfully subscribed to newsletter!');
    } catch (error) {
      if (error.response?.data?.message === 'Already subscribed') {
        toast.info('You are already subscribed!');
      } else {
        toast.error('Failed to subscribe. Please try again.');
      }
    }
    setLoading(false);
  };

  if (subscribed) {
    return (
      <div className="flex items-center gap-3 text-green-600">
        <CheckCircle className="h-5 w-5" />
        <span className="text-sm font-medium">Thank you for subscribing!</span>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="max-w-xs"
          data-testid="newsletter-email-compact"
        />
        <Button type="submit" disabled={loading} data-testid="newsletter-submit-compact">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Subscribe'}
        </Button>
      </form>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Mail className="h-5 w-5 text-primary" />
        <h3 className="font-heading text-lg font-semibold">Subscribe to Newsletter</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Get updates on new releases, exclusive offers, and reading recommendations.
      </p>
      <div className="space-y-3">
        <Input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="newsletter-name"
        />
        <Input
          type="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          data-testid="newsletter-email"
        />
        <Button type="submit" className="w-full btn-lift" disabled={loading} data-testid="newsletter-submit">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
          Subscribe
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        We respect your privacy. Unsubscribe at any time.
      </p>
    </form>
  );
};
